
import LicenseHelper from './licenseHelper';
import { IUser } from 'rt/UIApiControllers/Authentication/IUser';

class BlackFridayHelper {
  static getBlackFridayCampaign() {
    return '29375599-sds_black-friday';
  }

  static addParametersToUrl(url: string, user: IUser, fromPopup: boolean = false): string {
    if (LicenseHelper.isCRMDelSol(user)) {
      const utmSource = fromPopup ? 'emergente' : 'banner';
      const separator = url.includes('?') ? '&' : '?';
      url += `${separator}utm_campaign=${BlackFridayHelper.getBlackFridayCampaign()}&utm_source=${utmSource}`;
    }
    return url;
  }
}

export default BlackFridayHelper;
